import { keepZeroOrLine } from '@/utils/utils';
import { V2AlarmRecordAnalysisAlarmLevelStatisticsPostResponse } from '@maxtropy/device-customer-apis-v2';
import { isNil } from 'lodash-es';
import { DateType } from '../../const';
import circleImg from '../../imgs/circle@2x.png';
import circleBgImg from '../../imgs/circlebg-big@2x.png';

export const getChartOption = (
  alarmLevelStatistics?: V2AlarmRecordAnalysisAlarmLevelStatisticsPostResponse,
  pieLegendData?: any[]
) => {
  return {
    color: ['#FF4D4F', '#FFCB47', '#2D8DFF', '#16DD8E', '#ABD335'],
    legend: {
      show: false,
      left: 320,
      top: 'center',
      orient: 'vertical',
      icon: 'circle',
      itemGap: 10,
      itemHeight: 10,
      itemWidth: 10,
      textStyle: {
        rich: {
          name: {
            fontSize: 16,
            lineHeight: 20,
            width: 80,
          },
          value: {
            fontSize: 16,
            width: 120,
          },
        },
      },
      formatter: (name: string) => {
        const item = pieLegendData?.find(item => item.name === name);
        return `{name| ${item?.name}}{value| ${keepZeroOrLine(item?.value)}}`;
      },
    },
    title: {
      text: !isNil(alarmLevelStatistics?.totalNum) ? alarmLevelStatistics?.totalNum : '-',
      textStyle: {
        fontSize: 18,
        color: '#fff',
      },
      subtext: `总计`,
      subtextStyle: {
        fontSize: 18,
        color: 'rgba(255,255,255,0.65)',
      },
      left: 160,
      top: 72,
      itemGap: 8,
      textAlign: 'center',
    },
    graphic: {
      elements: [
        {
          type: 'image',
          style: {
            image: circleImg,
            x: 116,
            y: 46,
            width: 94,
            height: 94,
          },
        },
        {
          type: 'image',
          style: {
            image: circleBgImg,
            x: 116,
            y: 46,
            width: 94,
            height: 94,
          },
        },
      ],
    },
    series: [
      {
        type: 'pie',
        name: `总计`,
        percentPrecision: 5,
        minAngle: 2,
        padAngle: 1,
        radius: [52, 60],
        left: 130,
        top: 60,
        width: 66,
        height: 66,
        label: {
          show: false,
        },
        data: pieLegendData,
        showEmptyCircle: false,
      },
      {
        showEmptyCircle: false,
        data: pieLegendData,
        type: 'pie',
        percentPrecision: 5,
        padAngle: 1,
        minAngle: 2,
        left: 130,
        top: 60,
        name: `总计`,
        radius: [60, 76],
        width: 66,
        height: 66,
        emphasis: {
          disabled: true,
        },
        label: {
          show: false,
        },
        itemStyle: {
          opacity: 0.2,
        },
      },
    ],
  };
};
export const getBarChartOption = (
  alarmLevelStatistics?: V2AlarmRecordAnalysisAlarmLevelStatisticsPostResponse,
  timeResolution?: DateType
) => {
  const formatStr = timeResolution === DateType.CUSTOM || timeResolution === DateType.WEEK ? 'YYYY-MM-DD' : 'YYYY-MM';

  return {
    grid: {
      left: 20,
      right: 10,
      top: 30,
      bottom: 10,
      containLabel: true,
    },
    backgroundColor: 'transparent',
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        // let firstStr = dayjs(axisValue).format(formatStr);
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          otherStr += `<div style="margin-top:8px;width:200px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${seriesName}</div><div>${
            !isNil(data?.value) ? data?.value : '-'
          }</div></div>`;
          str = axisValue + otherStr;
        });

        return str;
      },
    },
    legend: {
      show: false,
    },
    xAxis: {
      type: 'category',
      data: (alarmLevelStatistics?.detailList ?? []).map(a => a.time),
      axisLabel: {
        // formatter: function (e: number) {
        //   return dayjs(e).format(formatStr);
        // },
        hideOverlap: true,
      },
      boundaryGap: true, // 或直接删掉
    },

    yAxis: {
      name: '报警（个）',
      type: 'value',
    },

    series: [
      {
        name: '最高级',
        stack: 'alarm',
        color: '#FF4D4F',
        type: 'bar',
        data: (alarmLevelStatistics?.detailList ?? []).map(a => ({
          value: a.topAlarmNum,
          startTime: a.startTime,
          endTime: a.endTime,
        })),
      },
      {
        name: '高级',
        stack: 'alarm',
        color: '#FFCB47',
        type: 'bar',
        data: (alarmLevelStatistics?.detailList ?? []).map(a => ({
          value: a.highAlarmNum,
          startTime: a.startTime,
          endTime: a.endTime,
        })),
      },
      {
        name: '中级',
        stack: 'alarm',
        color: '#2D8DFF',
        type: 'bar',
        data: (alarmLevelStatistics?.detailList ?? []).map(a => ({
          value: a.middleAlarmNum,
          startTime: a.startTime,
          endTime: a.endTime,
        })),
      },
      {
        name: '低级',
        stack: 'alarm',
        color: '#16DD8E',
        type: 'bar',
        data: (alarmLevelStatistics?.detailList ?? []).map(a => ({
          value: a.lowAlarmNum,
          startTime: a.startTime,
          endTime: a.endTime,
        })),
      },
      {
        name: '最低级',
        stack: 'alarm',
        color: '#ABD335',
        type: 'bar',
        data: (alarmLevelStatistics?.detailList ?? []).map(a => ({
          value: a.warningAlarmNum,
          startTime: a.startTime,
          endTime: a.endTime,
        })),
      },
    ],
  };
};
